import React, { lazy, Suspense, useEffect } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { Route, Switch } from 'react-router-dom';
import queryString from 'query-string';
import { useHistory } from 'react-router-dom';

import useInitPromo from 'client/hooks/useInitPromo/useInitPromo';
import useUserGamePhaseRedirectOnInit from 'client/hooks/useUserGamePhaseRedirectOnInit';

import ClientWrapper from 'client/components/ClientWrapper';
import ResultPage from 'client/components/Result/ResultPage';
import JoinGame from 'client/components/JoinGame/JoinGame';
import TransitionPage from 'client/components/JoinGame/TransitionPage';
import Form from 'client/components/form/Form';
import Lottery from 'client/components/Lottery/Lottery';
import Loading from 'client/components/Loading';
import DialogReCaptcha from 'components/Dialog/DialogReCaptcha';
import { useReCaptcha } from './hooks/useReCaptcha';
import useLogout from 'client/hooks/logout/useLogout';
import UploadPage from 'client/components/uploadPage/UploadPage';

const Prize = lazy(() =>
    import(/* webpackChunkName: "client_prize" */ 'client/components/Prize/PrizeContainer')
);

export default function AppPromoClient({
    match: {
        params: { promoUUID, promoId },
        path: matchedPath
    },
    location
}) {
    // 初始化後剛進入頁面時根據不同現狀條件，導向不同頁面(join / upload / transition / result)
    const { isInitialized } = useUserGamePhaseRedirectOnInit();
    const { isShowReCaptcha, setShowReCaptcha } = useReCaptcha();
    const initPromo = useInitPromo(promoUUID, promoId);
    const history = useHistory();
    const logout = useLogout();

    useEffect(() => {
        const parsed = queryString.parse(location.search);
        if (parsed.needLogout === 'true') {
            logout();
            const { needLogout, ...rest } = parsed;
            const newSearch = queryString.stringify(rest);
            history.replace({ search: newSearch });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.search, history]);

    if (!isInitialized) return <Loading />;

    return (
        <ClientWrapper>
            <Suspense fallback={<Loading />}>
                <TransitionGroup
                    childFactory={child =>
                        React.cloneElement(child, {
                            classNames: location.state?.transition ?? 'fever-fade-next'
                        })
                    }
                >
                    <CSSTransition timeout={200} key={location.pathname} unmountOnExit>
                        <>
                            {isShowReCaptcha && (
                                <DialogReCaptcha onOpen={setShowReCaptcha} onComplete={initPromo} />
                            )}
                            <Switch location={location}>
                                <Route path={`${matchedPath}/join`} component={JoinGame} />
                                <Route
                                    path={`${matchedPath}/transition`}
                                    component={TransitionPage}
                                />
                                <Route path={`${matchedPath}/result`} component={ResultPage} />
                                <Route path={`${matchedPath}/form`} component={Form} />
                                <Route
                                    path={`${matchedPath}/prize/:prizeUUID/:entriesUUID`}
                                    component={Prize}
                                />
                                <Route path={`${matchedPath}/lottery`} component={Lottery} />
                                <Route path={`${matchedPath}/upload`} component={UploadPage} />
                            </Switch>
                        </>
                    </CSSTransition>
                </TransitionGroup>
            </Suspense>
        </ClientWrapper>
    );
}
